export const baseURL = "https://metube.codderlab.com/";
// export const baseURL = "http://192.168.1.22:5086/";
export const secretKey = "0LF8bPi5BnOgl3JjLGcfhfU3N7TAk8rJ";
export const projectName = "Metube";
export const folderStructurePath = "meTube";